import { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FlightTakeoff } from '@mui/icons-material';
import { useRecoilValue } from 'recoil';
import atoms from '@Components/Utilities/SandhillsAtoms';
import TranslationText from '@Components/Utilities/TranslationText';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import TextField from '@Components/Shared/Controls/TextField'
import translator from '@Components/Utilities/Translator';

const FacetedSearchRangeField = (props) => {
    const routes = useRecoilValue(atoms.routes);
    const windowSize = useWindowSize();
    const [searching, setSearching] = useState(false);
    const [error, setError] = useState('');
    const [distance, setDistance] = useState(props.Distance > 0 ? props.Distance : '');
    const [airportCode, setAirportCode] = useState({ AirportCodeID: props.AirportID, AirportCityID: props.CityID, AirportCodeDisplay: props.AirportLabel });
    const distanceOptions = [10, 20, 50, 150, 200];

    const runSearch = () => {
        if (distance > 0 && airportCode) {
            if (airportCode.AirportCodeID || airportCode.AirportCityID) {
                setError('');
                setSearching(true);
                props.RunSearch({
                    fieldName: props.FieldName,
                    airport: airportCode,
                    distance: distance
                });
            } else {
                setError('Invalid City/Airport. Select value from dropdown.');
            }
        } else {
            setError('Invalid Search Request')
        }
    };

    const getAutoCompleteUrl = (e, url) => {
        return url;
    };

    const getAutoCompleteData = (e) => {
        return {
            text: e.target.value
        };
    };

    const onAirportChange = (e) => {
        let value = e.target.value;
        setAirportCode(previousState => {
            return { ...previousState, AirportCodeDisplay: value };
        });
    }

    return (
        <>
            {error && <div className='error' style={{ fontSize: '12px' }}>{error}</div>}
            <div className=''>
                <div className='boxed-input'>
                    <FlightTakeoff className='material-icon' />
                    <TextField
                        id='FromCityAirportCode'
                        name='FromCityAirportCode'
                        label={<TranslationText tKey='sandhills.tradesites.mvc.cityairportfrom' />}
                        value={airportCode?.AirportCodeDisplay}
                        type='text'
                        required={true}
                        updateField={(value, airportcodeid, cityid, lat, lng) => setAirportCode({ AirportCodeID: airportcodeid, AirportCityID: cityid, AirportCodeDisplay: value, lat: lat, lng: lng })}
                        onFieldChanged={onAirportChange}
                        autoComplete={{
                            ajaxUrl: (e) => getAutoCompleteUrl(e, routes.GetCityAirportCodeAutoComplete),
                            postData: (e) => getAutoCompleteData(e)
                        }}
                        useMUI
                        InputProps={{
                            disableUnderline: true,
                            sx: { fontSize: '14px' }
                        }}
                    />
                </div>
                <div className='boxed-input'>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="distance-select-label" className='shrink-label'>
                            <TranslationText tKey='sandhills.tradesites.mvc.distancefromairport' />
                        </InputLabel>
                        <Select
                            labelId="distance-select-label"
                            id="distance-select"
                            value={distance}
                            label={translator.translate('sandhills.tradesites.mvc.distancefromairport')}
                            onChange={(e) => setDistance(e.target.value)}
                            MenuProps={{
                                sx: {
                                    zIndex: 1600,
                                    '& .MuiMenuItem-root': {
                                        fontSize: '14px' 
                                    }
                                }
                            }}
                            inputProps={{
                                id: 'distance-select-label'
                            }}
                            sx={{ fontSize: '14px' }}
                        >
                            <MenuItem value=""><em><TranslationText tKey='sandhills.crm.dscrm.none' /></em></MenuItem>
                            {distanceOptions.map((name) => (
                                <MenuItem value={name}>{name} {props.IsMetric ? translator.translate('sandhills.tradepubwebsite.mvc.kilometersabrv') : translator.translate('sandhills.tradepubwebsite.mvc.miles')}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div>
            <button className='ts-button distance-search-button' onClick={runSearch}>
                {windowSize.isMobile ?
                    <TranslationText tKey='sandhills.apply' /> :
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.search' />}
            </button>
        </>
    );
};

export default FacetedSearchRangeField;